import React, { FC, useEffect, useState } from "react";
import { Typography, Box, makeStyles } from "@material-ui/core";
import { Colors } from "../../../helpers/theme";
import { ProjectListHomeProps } from "../../../interfaces";
import Moment from "react-moment";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#ffffff1c !important",
    "& .red": {
      color: Colors.red,
    },
  },
  logos: {
    width: "32px",
    height: "32px",
    borderRadius: "50px",
  },
}));
const MobileView: FC<ProjectListHomeProps> = ({
  id,
  imgSrc,
  title,
  price,
  roi,
  change,
}) => {
  const classes = useStyles();
  const [, setChangeColor] = useState("green");
  useEffect(() => {
    if (change === "- 46%") setChangeColor("red");
    else setChangeColor("green");
  }, []);
  return (
    <>
      <Box
        mb={1}
        className={`${classes.root} mobileview`}
        display="flex"
        justifyContent="space-between"
      >
        <Box display="flex" alignItems="center">
          <img
            src={imgSrc}
            className={`${classes.logos} img-fluid`}
            alt={title}
          />
          <Box>
            <Typography
              variant="body1"
              className="white font-family-Poppin fw-bold"
            >
              {title}
            </Typography>
            <Typography
              className=" white font-family-Poppin fw-normal"
              variant="subtitle1"
            >
              Ido price: ${price}
            </Typography>
          </Box>
        </Box>
        <Box
          textAlign="center"
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"40%"}
        >
          <Box
            style={{ backgroundColor: "#11302D" }}
            borderRadius={"10px"}
            padding={1.5}
            width={"50%"}
            className="white font-family-Poppin fw-bold"
          >
            {roi === null ? "x100" : parseFloat(roi).toFixed(1) + " x"}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default MobileView;
